import React, { Component } from 'react';
import { View } from 'react-native';
import { observer } from 'mobx-react';
import moment from 'moment';

import Modal from '../../shared/Modal';
import Text from '../../shared/Text';

import { IS_WEB } from '../../../lib/appConstants';

import { PADDING1, MARGIN_5 } from '../../styleConstants';

import { CombatType } from '../../../lib/types';

import warriorInfoModalStore from '../../common/WarriorInfoModal/store';

import Log from '../../common/CombatLog';

import store from './store';
import WarriorsLine from '../../common/WarriorsLine';

import { t } from '../../../utils/appUtils';

type Props = {
  onHide: () => void;
  combat: CombatType;
};

type State = {
  combats: CombatType[];
};

@observer
export default class CombatLogModal extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    store.setCombat(props.combat);
  }

  componentWillUnmount() {
    store.clear();
  }

  render() {
    const { onHide } = this.props;
    const { combat } = store;

    return (
      <Modal
        fullScreen
        onHide={onHide}
        overlay={Boolean(warriorInfoModalStore.warrior)}
        title={t('combat.combatLog')}
        warriorListener
      >
        <View
          style={{
            padding: 30,
            marginTop: 20,
            flex: 1,
          }}
        >
          <WarriorsLine
            combat={combat}
            notListenWarriorChanges
            fetchWarrior
            showHp
            beforeRenderer={() => (
              <Text bold style={{ marginRight: MARGIN_5 }}>
                {moment(combat.created).format('MMM Do hh:mm')}
              </Text>
            )}
            afterRenderer={() => (
              <Text bold>
                {` ${t('island.position')}: ${combat.location.coordinateX}:${
                  combat.location.coordinateY
                }`}
              </Text>
            )}
          />
          <View
            style={{
              height: (IS_WEB ? 'calc(100% - 60px)' : '100%') as any,
              marginTop: PADDING1,
            }}
          >
            <Log combat={combat} />
          </View>
        </View>
      </Modal>
    );
  }
}
